/**
 * DVL manual link — lift it out of the collapsed tab
 * ==================================================
 * The housing manual is authored by EQA as `<div class="dvl-manual" data-dvl="manual">` inside the
 * product description. On every theme that description lives in `div.dvl-tabs-panel`, which is
 * `display:none` until the shopper opens the tab — so the link was not merely unstyled, it was not on
 * screen at all. Styling it (dvl-manual.css) fixes how it looks; this puts it where it can be looked at.
 *
 * It COPIES rather than moves: the description is re-rendered client-side per variant
 * (variant-description.js), and a node moved out of it would be destroyed by the next swap — or worse,
 * leave the description missing a section. The copy is rebuilt from whatever the description currently
 * holds, so a variant with a different manual gets its own.
 *
 * Placed after the add-to-cart form, the one anchor all four themes share and show:
 *   Fashionopolism form.product__form-container · Galleria form.shopify-product-form
 *   Prestige form.ProductForm · Dawn form[action*="/cart/add"]
 *
 * Idempotent, and re-runs on description changes — the same reason dvl-faq.js delegates on document.
 */
(function () {
  'use strict';

  var OUT = 'dvl-manual-out';
  var ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
    '<path d="M14 2v6h6"/><path d="M8 13h8"/><path d="M8 17h5"/></svg>';

  function source() {
    // the authored block, wherever the description currently is
    var box = document.querySelector('.dvl-manual a[href]');
    return box || null;
  }

  function anchor() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var r = forms[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return forms[i];   // the visible one; themes ship hidden dupes
    }
    return null;
  }

  function render() {
    var src = source();
    var host = anchor();
    var existing = document.querySelector('.' + OUT);

    // no manual on this product (or this variant) — take the copy away again
    if (!src || !host) {
      if (existing) existing.parentNode.removeChild(existing);
      return;
    }

    var href = src.getAttribute('href');
    var label = (src.textContent || '').trim() || 'User manual';

    if (existing && existing.getAttribute('data-href') === href) return;  // already correct
    if (existing) existing.parentNode.removeChild(existing);

    var box = document.createElement('div');
    box.className = OUT;
    box.setAttribute('data-href', href);

    var icon = document.createElement('span');
    icon.className = OUT + '__icon';
    icon.innerHTML = ICON;

    var a = document.createElement('a');
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = label;
    var t = src.getAttribute('title');
    if (t) a.title = t;

    var hint = document.createElement('span');
    hint.className = OUT + '__new';
    hint.textContent = '(opens in a new tab)';

    box.appendChild(icon);
    box.appendChild(a);
    box.appendChild(hint);
    host.parentNode.insertBefore(box, host.nextSibling);
  }

  function boot() {
    render();

    /* The description is replaced wholesale on a variant change, so watch for it. Scoped to a
       container rather than document where one can be found: observing the whole body on a product
       page with a gallery and a kit drawer is a lot of callbacks for one link. */
    var scope =
      document.querySelector('.dvl-tabs-panel') ||
      document.querySelector('[class*="description"]') ||
      document.body;

    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;                  // coalesce a burst of mutations into one render
      pending = setTimeout(function () {
        pending = null;
        render();
      }, 120);
    });
    mo.observe(scope, { childList: true, subtree: true });

    // belt and braces: the themes' own variant events, where they exist
    document.addEventListener('variant:change', render, false);
    document.addEventListener('variantChange', render, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, false);
  } else {
    boot();
  }
})();
